import React, { useState, useEffect } from "react";

const words = [
  "Balanced Meal",
  "Fruit Bowl",
  "Mega Healthy",
  "Ultra Fresh",
  "Sprout Bowl",
  "White Egg Bowl",
  "Signature Egg Bowl",
  "Grilled Chicken",
  "Chipotle Chicken",
];

// Pass headingTag="h1" when this is the page's main heading (e.g. Subscription).
const FreshMealPlansHeading = ({ headingTag: Heading = "h2" }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % words.length);
    }, 3000);

    return () => clearInterval(timer);
  }, []);

  return (
    <Heading className="story-hero-head text-[2rem] font-bold uppercase leading-[1.1] text-[#1f5c33] sm:text-[2.5rem] md:text-5xl">
      <span className="block">Fresh Meal Plans</span>
      <span className="sr-only">for every day</span>
      {/* every word sits in the same grid cell, so the line is as wide as the
          longest word and nothing below it jumps when the word changes */}
      <span aria-hidden="true" className="mt-1 inline-grid text-green-600">
        {words.map((word, index) => (
          <span
            key={word}
            className="col-start-1 row-start-1 transition-all duration-700"
            style={{
              opacity: index === currentIndex ? 1 : 0,
              transform: `translateY(${index === currentIndex ? 0 : "0.4em"})`,
            }}
          >
            {word}
          </span>
        ))}
      </span>
    </Heading>
  );
};

export default FreshMealPlansHeading;
